"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GeolocationParams = require('./GeolocationParams.js');

var TimezoneParams = require('./TimezoneParams.js');

module.exports = /*#__PURE__*/function () {
  function IPGeolocationAPI() {
    var apiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, IPGeolocationAPI);

    this.apiKey = apiKey;
    this.async = async;
  }

  _createClass(IPGeolocationAPI, [{
    key: "getGeolocation",
    value: function getGeolocation(callback) {
      var geolocationParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (geolocationParams && geolocationParams.getIPAddresses()) {
        var jsonData = JSON.stringify({
          'ips': geolocationParams.getIPAddresses()
        });
        postRequest('ipgeo-bulk', buildGeolocationUrlParams(this.apiKey, geolocationParams), jsonData, callback);
      } else {
        getRequest('ipgeo', buildGeolocationUrlParams(this.apiKey, geolocationParams), callback);
      }
    }
  }, {
    key: "getTimezone",
    value: function getTimezone(callback) {
      var timezoneParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return getRequest('timezone', buildTimezoneUrlParams(this.apiKey, timezoneParams), callback);
    }
  }, {
    key: "getApiKey",
    value: function getApiKey() {
      return this.apiKey;
    }
  }, {
    key: "isAsync",
    value: function isAsync() {
      return this.async;
    }
  }]);

  return IPGeolocationAPI;
}();

function buildGeolocationUrlParams() {
  var apiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var geolocationParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var urlParams = '';

  if (apiKey) {
    urlParams = urlParams.concat('apiKey=', apiKey);
  }

  if (geolocationParams) {
    if (geolocationParams.getIPAddress()) {
      if (urlParams) {
        urlParams = urlParams.concat('&');
      }

      urlParams = urlParams.concat('ip=', geolocationParams.getIPAddress());
    }

    if (geolocationParams.getFields()) {
      if (urlParams) {
        urlParams = urlParams.concat('&');
      }

      urlParams = urlParams.concat('fields=', geolocationParams.getFields());
    }

    if (geolocationParams.getExcludes()) {
      if (urlParams) {
        urlParams = urlParams.concat('&');
      }

      urlParams = urlParams.concat('excludes=', geolocationParams.getExcludes());
    }

    if (geolocationParams.getLang()) {
      if (urlParams) {
        urlParams = urlParams.concat('&');
      }

      urlParams = urlParams.concat('lang=', geolocationParams.getLang());
    }
  }

  return urlParams;
}

function buildTimezoneUrlParams() {
  var apiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var timezoneParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var urlParams = '';

  if (apiKey) {
    urlParams = urlParams.concat('apiKey=', apiKey);
  }

  if (timezoneParams) {
    if (timezoneParams.getIPAddress()) {
      if (urlParams) {
        urlParams = urlParams.concat('&');
      }

      urlParams = urlParams.concat('ip=', timezoneParams.getIPAddress());
    }

    if (timezoneParams.getTimezone()) {
      if (urlParams) {
        urlParams = urlParams.concat('&');
      }

      urlParams = urlParams.concat('tz=', timezoneParams.getTimezone());
    }

    if (timezoneParams.getLatitude() !== '1000.0' && timezoneParams.getLongitude() !== '1000.0') {
      if (urlParams) {
        urlParams = urlParams.concat('&');
      }

      urlParams = urlParams.concat('lat=', timezoneParams.getLatitude(), '&long=', timezoneParams.getLongitude());
    }

    if (timezoneParams.getLang()) {
      if (urlParams) {
        urlParams = urlParams.concat('&');
      }

      urlParams = urlParams.concat('lang=', timezoneParams.getLang());
    }
  }

  return urlParams;
}

function getRequest(subUrl) {
  var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  var jsonData = {};

  var XMLHttpRequest = require('xmlhttprequest').XMLHttpRequest;

  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status == 0) {
        jsonData = {
          'message': 'Internet is not connected!'
        };
      } else {
        jsonData = JSON.parse(this.responseText);
      }

      if (callback && _typeof(callback) === (typeof Function === "undefined" ? "undefined" : _typeof(Function))) {
        callback(jsonData);
      } else {
        console.error("Passed callback '".concat(callback, "' is not a valid Function."));
      }
    }
  };

  xhr.withCredentials = true;
  xhr.open('GET', 'https://api.ipgeolocation.io/'.concat(subUrl, '?', urlParams, ''), this.async);
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.send();
}

function postRequest(subUrl) {
  var urlParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var requestData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var callback = arguments.length > 3 ? arguments[3] : undefined;
  var jsonData = {};

  var XMLHttpRequest = require('xmlhttprequest').XMLHttpRequest;

  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status == 0) {
        jsonData = {
          'message': 'Internet is not connected!'
        };
      } else {
        jsonData = JSON.parse(this.responseText);
      }

      if (callback && _typeof(callback) === (typeof Function === "undefined" ? "undefined" : _typeof(Function))) {
        callback(jsonData);
      } else {
        console.error("Passed callback '".concat(callback, "' is not a valid Function."));
      }
    }
  };

  xhr.withCredentials = true;
  xhr.open('POST', 'https://api.ipgeolocation.io/'.concat(subUrl, '?', urlParams, ''), this.async);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.send(requestData);
}